import { Button, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import LetsTalkModal from '../../SponsorContactForm';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 92px;
  flex-direction: column;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    margin-top: 22px;
    width: 100vw;
  }
`;

const ContentArea = styled.div`
  width: 1140px;

  @media (max-width: 1024px) {
    flex-direction: column;
    display: flex;
    align-items: center;
    width: auto;
    margin: 0 13px;
  }

  .header {
    color: ${theme.SECONDARY};
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 18px;

    @media (max-width: 1024px) {
      font-size: 20px;
      max-width: 500px;
      margin-bottom: 12px;
    }
  }

  .content {
    width: 700px;
    font-size: 20px;
    line-height: 26px;
    margin-top: 15px;

    @media (max-width: 1024px) {
      margin-top: 9px;
      font-size: 14px;
      line-height: 18px;
      max-width: 500px;
      width: inherit;
    }
  }

  button {
    margin-top: 43px;

    @media (max-width: 1024px) {
      align-self: start;
      margin-top: 60px;
    }
  }
`;

const Sponsor = (props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  function handleClick() {
    setVisible(!visible);
  }

  return (
    <Wrapper>
      <ContentArea>
        <Text className="header">{t('website.becomeASponsor')}</Text>
        <Text className="content">
          {/*
            Uncomment once added
            {t("website.content1")}
          */}
        </Text>

        <Text className="content">
          {/*
            Uncomment once added
            {t("website.content2")}
          */}
          <Button website wid="178px" ht="54px" text={`Let's talk`} onClick={handleClick} />

          <LetsTalkModal website visible={visible} closeModal={handleClick} />
        </Text>
      </ContentArea>
    </Wrapper>
  );
};

export default Sponsor;
